import React,{useState,useEffect,useRef} from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { GET_SCHEPASSENGER_LIST,GET_LOCATION_URL,GET_DRIVER_URL,ADD_SCHEDULE_URL,CHECK_DRIVER_AVAILABILITY } from '../constant'; 
import axios from 'axios';
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import {dateFormat,restrictNumberInput,onlyNumberInput,restrictSpecialCharacters} from "../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import TimePicker from '../components/TimePicker';
import PopupModal from '../components/popupModal';
import EditableDropDown from '../components/EditableDropDown';
import calender from '../assets/images/calendar.png';
import SelectDropDown from '../components/SelectDropDown';
import SaveButton  from '../components/buttons/SaveButton';
import CancelButton from '../components/buttons/CancelButton';
import {currentDateFormat} from "../utils";
import { useNavigate } from "react-router-dom";
import{scheduleFormValidation,validateAccordion,validateLegs} from "../validation/Validation";
import { Circles } from 'react-loader-spinner';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import {TimeInput} from "@nextui-org/react";
import moment from 'moment';
import {DistanceMatrixService } from '@react-google-maps/api';
import Swal from '../messageBox/customSweetAlert';
//import { useEffect, useState } from 'react';

// Add a function to calculate distance using Google Maps API


const Schedule = () =>{
  const prevAccordionsRef = useRef();
  const navigate = useNavigate();
  const [errors,setErrors] = useState({});
  const datepickerRef = useRef(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
    const [passengers, setPassengers] = useState([]);
    const [selectedPassenger, setSelectedPassenger] = useState({label:'', value: {} });
    const [filteredPassenger, setFilteredPassenger] = useState(null);
    const [location, setLocation] = useState([]);
    const [scheduleDate, setScheduleDate] = useState();
    const [currentDate,setCurrentDate] = useState(new Date());
    const [assignedDriver, setAssignedDriver] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [pickUpLocation, setPickUplocation] = useState(null);
    const [dropOffLocation, setDropOffLocation] = useState(null);
    const [pickUpTime, setPickUpTime] = useState(null);
    const [dropOffTime, setDropOffTime] = useState(null);
    
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [locationValue, setLocationValue] = useState({
      loc_address:'',
      loc_city: '',
      loc_name: '',
      loc_state: '',
      loc_type:'',
      loc_zip:'',
      pass_id:''});
    const [scheduleDetails,setScheduleDetails] = useState({schedule_date:'',
      location_type:'',
      wheel_chair:'',
      stretcher:'',
      assigned_driver:'',
      number_of_leg:'2',
      bill_amount:'' ,
      date_mode:'single',
      hour:'',
      minute:'',
      frequency: 'daily', // Add frequency field
      selectedDays: [], // Add selected days field
      has_companions: 'No', // Add companion field
      companion_count: '' // Add companion count field
    });
    //const [loading, setLoading] = useState(false);
    const [setValue, setSetValue] = useState(false);
    const [accordionsWithError,setAccordionsWithError] = useState([]);
    const [selectedPickUpLocations, setSelectedPickUpLocations] = useState({});
    const [isWait, setIsWait] = useState('');
    const [minutes, setMinutes] = useState('');
    const [seconds, setSeconds] = useState('');
    const [totalDistance, setTotalDistance] = useState('');
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropoffAddress, setDropoffAddress] = useState('');
    const [allLocations, setAllLocations] = useState('');
    const [overlapedTimes, setOverlapedTimes] = useState([]);
    const [locationErrors, setLocationErrors] = useState({});
    const [hasCompanions, setHasCompanions] = useState('No');
    const [companionCount, setCompanionCount] = useState('');

const [numberOfLeg, setNumberOfLeg] = useState("2");
const [disabledInput, setDisabledInput] = useState(true);
const [frequency, setFrequency] = useState('daily');
const [selectedDays, setSelectedDays] = useState([]);
   

    //ACCORDANCE 
    const [maxLegs, setMaxLegs] = useState(0);
    const [accordions, setAccordions] = React.useState([
    { id: 1, expanded: true,  pick_up_loc: '', number_of_leg:'2', pickup_latitude: '', pickup_longitude: '', dropoff_latitude: '', dropoff_longitude: ''},
    { id: 2, expanded: false,  pick_up_loc: '', number_of_leg:'2', pickup_latitude: '', pickup_longitude: '', dropoff_latitude: '', dropoff_longitude: ''}
  ]);

  // Step 2: Function to add a new Accordion
  const handleAddAccordion = () => {
    if (accordions.length < maxLegs) {
      const newId = accordions.length + 1;
      setAccordions([...accordions, { 
        id: newId, 
        expanded: false,
        pickup_latitude: '',
        pickup_longitude: '',
        dropoff_latitude: '',
        dropoff_longitude: ''
      }]);
    }
  };

  // Step 3: Function to toggle an Accordion's expanded state
  const handleToggle = (id) => {
    setAccordions((prev) =>
      prev.map((accordion) =>
        accordion.id === id ? { ...accordion, expanded: true } : { ...accordion, expanded: false }
      )
    );
  };
 
  // Step 4: Handle input changes for each Accordion
  const handleAccordianInputChange = async (id, field, value) => {
     if (field === "number_of_leg") {
      const numLegs = parseInt(value);
      setMaxLegs(numLegs);
      setNumberOfLeg(numLegs);

      const currentAccordionsLength=accordions.length;
      if(currentAccordionsLength < numLegs){
        const newAccordions = Array.from({ length: (numLegs-currentAccordionsLength) }, (_, index) => ({
          id: currentAccordionsLength+index + 1,
          expanded: false,
          pickup_latitude: '',
          pickup_longitude: '',
          dropoff_latitude: '',
          dropoff_longitude: ''
        }));
        setAccordions([...accordions,...newAccordions]);
      }else{
        setAccordions([...accordions.slice(0,numLegs)]);
      }
      setScheduleDetails((prev) => ({
        ...prev,
        number_of_leg: numLegs, // Set the number of legs
        [field]: value
      }));
    }else{
    
   // const newAcordionList = [];
    let localAccordions=[...accordions];


    localAccordions=  localAccordions.map((accordion) => {
      if (accordion.id === id) {
        //console.log("localAccordions",id);
        const updatedAccordion = { ...accordion, [field]: value };
        // If updating Leg 1's pick_up_loc, update Leg 2's drop_off_loc if it was set to the previous pick_up_loc
       //console.log("updatedAccordion",updatedAccordion);
        if (id === 1 && field === 'pick_up_loc') {
          const leg2 = localAccordions.find(a => a.id === 2);
          if (leg2 ) {
            localAccordions[1].drop_off_loc = value;
          }
        }
        if (id === 1 && field === 'drop_off_loc') {
          const leg2 = localAccordions.find(a => a.id === 2);
          if (leg2 ) {
            localAccordions[1].pick_up_loc = value;
          }
        }
        return updatedAccordion;
      }
      return accordion;
    });
    localAccordions.forEach(accordion=>{
          const pickUp = accordion.pick_up_loc;
        const dropOff = accordion.drop_off_loc;

        if (pickUp && dropOff && Number(pickUp) === Number(dropOff)) {
          setLocationErrors((prev) => ({
            ...prev,
            [accordion.id]: 'Pickup and Drop-off locations cannot be the same.'
          }));
        } else {
          setLocationErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[accordion.id];
            return newErrors;
          });
        }
        });
    
    if (((field === 'pick_up_time' || field === 'drop_off_time' ))) {
      const isDriverAvailable = await checkDriverAvailability(scheduleDetails.assigned_driver, moment(scheduleDate).format('YYYY-MM-DD'), value);
    
      if (isDriverAvailable === '400') {
        //alert('The assigned driver is not available at the selected time.');
      setOverlapedTimes((prevOverlapedTimes) => [...prevOverlapedTimes, id]);
        Swal.fire({
          title: 'Failed!',
          text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",
          
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
        //return ;

      }else{
         setOverlapedTimes((prevOverlapedTimes) => prevOverlapedTimes.filter((item) => item !== id));
      }
      
    }
 // Merge overlapedTimes into accordions
  //setAccordions([...localAccordions, ...overlapedTimes]);
     setAccordions(localAccordions);
     
  }
  
  setScheduleDetails((prev) => ({
    ...prev,
    [field]: value
  }));
 
  
   
  }
  

  const checkDriverAvailability = async (driverId, date, time) => {
    try {
      if(driverId && time != 'Will Call'){

      
      dispatch(setLoading(true));
      const response = await axios.post(CHECK_DRIVER_AVAILABILITY, {
        driverId,
        date,
        time
      });
      if(response.data.status === '200'){
        dispatch(setLoading(false));
        //setErrors(null);
        return response.data.status;
      }else{
        dispatch(setLoading(false));
        const validationErrors = {};
        //validationErrors.validError = "ERROR";
        //setErrors(validationErrors);
        return response.data.status;
      }
    }
    } catch (error) {
      dispatch(setLoading(false));
      console.error('Error checking driver availability:', error);
      return false;
    }
  };

  const handleInputChange=(e)=>{
    const {name,value,checked} = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    setScheduleDetails((prev)=>{
      console.log("name",value);
      return{
        ...prev,
        [name]:value,
        frequency: frequency, // Ensure frequency is always included
        selectedDays: selectedDays, // Ensure selectedDays is always included
       pass_id  : selectedPassenger.value?.passenger?.passenger_id ??'',
       payer_id : selectedPassenger.value?.passenger?.payer?.id ??'',
      }
    });
    if (name === 'is_wait') {
      setIsWait(value);
      // Reset minutes and seconds when changing the selection
      setMinutes('');
      setSeconds('');
    }
     
   if (name === 'location_type') {
    if (value === '5') {
      setDisabledInput(false);
    } else {
      setDisabledInput(true);
    }
  }
    
}

// Add function to handle frequency change
const handleFrequencyChange = (newFrequency) => {
  console.log('Frequency changed to:', newFrequency);
  
  setFrequency(newFrequency);
  setScheduleDetails(prev => ({
    ...prev,
    frequency: newFrequency
  }));
  
  // Reset selected days when frequency changes
  if (newFrequency === 'daily') {
    setSelectedDays([]);
    setScheduleDetails(prev => ({
      ...prev,
      selectedDays: []
    }));
  }
};

// Add function to handle day selection
const handleDaySelection = (day) => {
  const newSelectedDays = selectedDays.includes(day)
    ? selectedDays.filter(d => d !== day)
    : [...selectedDays, day];
  
  console.log('Day selection changed:', { day, newSelectedDays });
  
  setSelectedDays(newSelectedDays);
  setScheduleDetails(prev => ({
    ...prev,
    selectedDays: newSelectedDays
  }));
};

// Add companion handling functions
const handleCompanionChange = (value) => {
  setHasCompanions(value);
  if (value === 'No') {
    setCompanionCount('');
  }
  setScheduleDetails(prev => ({
    ...prev,
    has_companions: value,
    companion_count: value === 'No' ? '' : companionCount
  }));
};

const handleCompanionCountChange = (e) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) { // Only allow digits
    setCompanionCount(value);
    setScheduleDetails(prev => ({
      ...prev,
      companion_count: value
    }));
  }
};

    const search = (event) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredPassengers;

            if (!event.query.trim().length) {
              _filteredPassengers = [...passengers];
            }
            else {
              const regex = new RegExp(`${event.query}`,"gi");
              _filteredPassengers =  passengers.filter((user) => {
                    return (
                      user.first_name?.match(regex) || user.passenger.pass_pmi_no?.match(regex)
                    );
                  }).map((user) => {
                    return {
                      label: `${user.first_name}`+' '+`${user.middle_name}`+' '+`${user.last_name} - ${user.passenger.pass_pmi_no}`,
                      value: user
                    };
                  });
            }
            setFilteredPassenger(_filteredPassengers);
        }, 250);
    }

    const handleResetAddValue = () => {
      setLocationValue({}); // Reset addValue to an empty object
    };

    const handleLocationSelect = async (passengerId)=>{
      
      const response1 = await axios.get(GET_LOCATION_URL+`/${ passengerId.value?.passenger?.passenger_id ?? ''}`);
      const response2 = await axios.post(GET_DRIVER_URL);
      setLocation(response1.data);

      setAssignedDriver(response2?.data?.result);
      
    }
    
  useEffect(() => {
      const loadUser = async ()=>{
        const response = await axios.get(GET_SCHEPASSENGER_LIST);
        setPassengers(response.data)
      }
    loadUser();
  }, []);

  useEffect(() => {
    if(selectedPassenger.value?.passenger?.passenger_id){
      const loadLocation = async ()=>{
        const response1 = await axios.get(GET_LOCATION_URL+`/${ selectedPassenger.value?.passenger?.passenger_id ?? ''}`);
        //setLocation(response1.data);
        //console.log("loc+++",response1.data);
        const locations = response1.data;
      //const _pickupLocation = locations.filter((option) => option.loc_type === 1);
      //const _dropOffLocation = locations.filter((option) => option.loc_type === 2);
      const _pickupLocation = locations.filter((option) => option.loc_type === 1);
      const _dropOffLocation = locations.filter((option) => option.loc_type === 2);
      setPickUplocation(_pickupLocation);
      setDropOffLocation(_dropOffLocation);
      setAllLocations(locations);
     }
     loadLocation();
    }
}, [selectedPassenger,locationValue,setValue]);
useEffect(() => {
  const handleInputChangeWrapper = (event) => {
    handleInputChange(event);
  };
  handleInputChangeWrapper({ target: { value: selectedValue } });
}, [selectedValue,pickUpLocation,dropOffLocation,dropOffTime,pickUpTime]);

useEffect(() => {
  //  if ((pickUpLocation && pickUpLocation.length > 0 ) || (dropOffLocation && dropOffLocation.length) > 0) {
  //   const modifiedFirstAccordion = {
  //     ...accordions[0],
  //     pick_up_loc: pickUpLocation[0]?.loc_id,
  //     drop_off_loc: dropOffLocation[0]?.loc_id
  //   };

  //   const modifiedSecondAccordion = {
  //     ...accordions[1],
  //     pick_up_loc: modifiedFirstAccordion.drop_off_loc,
  //     drop_off_loc: modifiedFirstAccordion.pick_up_loc // Initially empty
  //   };

  //   setAccordions([modifiedFirstAccordion, modifiedSecondAccordion, ...accordions.slice(2)]);
  // }
  const numberOfLegs = parseInt(scheduleDetails?.number_of_leg || 2);

  if ((pickUpLocation?.length > 0) || (dropOffLocation?.length > 0)) {
    const updatedAccordions = [];

    for (let i = 0; i < numberOfLegs; i++) {
      if (i === 0) {
        // First leg - use pickup and dropoff from location arrays
        updatedAccordions.push({
          ...accordions[i],
          id: i + 1,
          expanded: true,
          pick_up_loc: pickUpLocation[0]?.loc_id || '',
          drop_off_loc: dropOffLocation[0]?.loc_id || '',
          number_of_leg: String(numberOfLegs),
          pickup_latitude: '',
          pickup_longitude: '',
          dropoff_latitude: '',
          dropoff_longitude: ''
        });
      } else {
        // Other legs - optionally pre-fill with previous drop-off
        updatedAccordions.push({
          ...accordions[i],
          id: i + 1,
          expanded: i === 1,
          pick_up_loc: dropOffLocation[0]?.loc_id || '',
          drop_off_loc: '',
          number_of_leg: String(numberOfLegs),
          pickup_latitude: '',
          pickup_longitude: '',
          dropoff_latitude: '',
          dropoff_longitude: ''
        });
      }
    }

    setAccordions(updatedAccordions);
  }

  // console.log("accordions",accordions);
  
}, [pickUpLocation,dropOffLocation,scheduleDetails?.number_of_leg]);

// Add useEffect to sync frequency and selectedDays with scheduleDetails
useEffect(() => {
  console.log('Syncing frequency and selectedDays:', { frequency, selectedDays });
  setScheduleDetails(prev => ({
    ...prev,
    frequency: frequency,
    selectedDays: selectedDays
  }));
}, [frequency, selectedDays]);

// Debug useEffect to log scheduleDetails changes
useEffect(() => {
  console.log('scheduleDetails changed:', scheduleDetails);
}, [scheduleDetails]);

// Debug useEffect to log errors changes
useEffect(() => {
  console.log('Errors state changed:', errors);
  if (errors.selectedDays) {
    console.log('selectedDays error found:', errors.selectedDays);
  }
  if (errors.frequency) {
    console.log('frequency error found:', errors.frequency);
  }
}, [errors]);

const handlePassengerChange = (passenger) => {
  setSelectedPassenger(passenger);
  setPickupAddress('');
  setDropoffAddress('');
  setTotalDistance('');
};

async function handleFormSubmit(e) {
  //console.log("scheduleDetails",scheduleDetails);
  //return false;
  e.preventDefault();
  console.log('Form submitted!');
  //alert("hai");
//console.log( overlapedTimes );
  const allErrors = {};
  const accordionsWithError = []; 
 setOverlapedTimes([]);
if(overlapedTimes.length > 0){
  Swal.fire({
    title: 'Failed!',
    text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",
    icon: 'warning',
    confirmButtonText: 'OK',
    allowOutsideClick: false
  }).then(() => {
    // Reset overlapedTimes after showing the error message
    setOverlapedTimes([]);
  });
  return false; // Exit the function if there are errors

}
if (Object.keys(locationErrors).length > 0) {
    Swal.fire({
      title: 'Failed',
      text: 'Please ensure pickup and drop-off locations are not the same.',
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    });
    return false;
  }
  
  // Create a complete schedule details object with current state
  const completeScheduleDetails = {
    ...scheduleDetails,
    frequency: frequency,
    selectedDays: selectedDays
  };
  
  console.log('=== FORM SUBMISSION DEBUG ===');
  console.log('scheduleDetails:', scheduleDetails);
  console.log('frequency state:', frequency);
  console.log('selectedDays state:', selectedDays);
  console.log('completeScheduleDetails:', completeScheduleDetails);
  console.log('date_mode:', completeScheduleDetails.date_mode);
  console.log('start_date:', completeScheduleDetails.start_date);
  console.log('end_date:', completeScheduleDetails.end_date);
  console.log('=== END DEBUG ===');
  
  // Check if we're in range mode and have weekly/biweekly frequency
  if (completeScheduleDetails.date_mode === 'range' && 
      (completeScheduleDetails.frequency === 'weekly' || completeScheduleDetails.frequency === 'biweekly')) {
    console.log('Weekly/Biweekly validation should trigger');
    console.log('selectedDays length:', completeScheduleDetails.selectedDays ? completeScheduleDetails.selectedDays.length : 'undefined');
  }
  
  const isValid = scheduleFormValidation(completeScheduleDetails);
  console.log('Validation errors:', isValid);
  console.log('Number of validation errors:', Object.keys(isValid).length);
  console.log('Has selectedDays error:', !!isValid.selectedDays);
  console.log('Has frequency error:', !!isValid.frequency);
  //return false;
     setErrors(isValid);
     accordions.forEach((accordion) => {
      const errors = validateAccordion(
        accordion,
        scheduleDetails.schedule_date,
        scheduleDetails.date_mode,
        scheduleDetails.start_date,
        scheduleDetails.end_date
      );
      if (Object.keys(errors).length > 0) {
        allErrors[accordion.id] = errors; // Store errors by accordion ID
        accordionsWithError.push(accordion.id);
      }
    });
    // Validate leg times
  const legValidationErrors = validateLegs(accordions);
  if (Object.keys(legValidationErrors).length > 0) {
    Object.keys(legValidationErrors).forEach((key) => {
      //alert(parseInt(key.match(/\d+/)[0], 10) );
      const legIndex = parseInt(key.match(/\d+/)[0], 10) - 1;
      if (!allErrors[accordions[legIndex].id]) {
        allErrors[accordions[legIndex].id] = {};
      }
      const errorKey = key.replace(/_\d+$/, '');
      allErrors[accordions[legIndex].id][errorKey] = legValidationErrors[key];
      if (!accordionsWithError.includes(accordions[legIndex].id)) {
        accordionsWithError.push(accordions[legIndex].id);
      }
    });
  }
    if (Object.keys(allErrors).length > 0) {
      setErrors(allErrors); // Update state with validation errors
      setAccordionsWithError(accordionsWithError);
      return; // Exit the function if there are errors
    }
     if(Object.keys(isValid).length === 0){
       console.log('No validation errors, proceeding with form submission');
  try {
    dispatch(setLoading(true));
      const payload = {
        scheduleDetails: completeScheduleDetails,
        accordions,
      };
      const response = await axios.post(ADD_SCHEDULE_URL, payload);
      
      //console.log(response.data.status);
      if (response.data.status === '200') {
        dispatch(setLoading(false));
          navigate('list');
          Swal.fire({
            title: 'Success!',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          });
      } else {
        dispatch(setLoading(false));
          Swal.fire({
              title: 'Failed!',
              text: response.data.message,
              icon: 'Error',
              confirmButtonText: 'OK',
              allowOutsideClick: false
            });
          //console.log(response.data.message);
      }
  } catch (error) {
    dispatch(setLoading(false));
    if (error.response && error.response.data) {
    console.error('Backend Error:', error.response.data);

    Swal.fire({
      title: 'Error!',
      text: error.response.data.message || 'Server responded with an error.',
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    });
  } else {
    console.error('Unexpected Error:', error);
    Swal.fire({
      title: 'Error!',
      text: 'Unexpected error occurred. Please try again later.',
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    });
  }
  }
} else {
  console.log('Validation errors found, stopping form submission');
}
}

// useEffect(() => {
//   const calculateDistance = (pickup, dropoff, setDistance) => {
//     if (!pickup || !dropoff) return;

//     fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(pickup)}&key=AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI`)
//   .then(response => response.json())
//   .then(data => {
//     if (data.status === "OK") {
//       const location = data.results[0].geometry.location;
//       console.log("Latitude:", location.lat);
//       console.log("Longitude:", location.lng);
//     } else {
//       console.error("Geocoding failed:", data.status);
//     }
//   })
//   .catch(error => console.error("Error:", error));
  
//     // const service = new window.google.maps.DistanceMatrixService();
//     // service.getDistanceMatrix(
//     //   {
//     //     origins: [pickup],
//     //     destinations: [dropoff],
//     //     travelMode: window.google.maps.TravelMode.DRIVING,
//     //   },
//     //   (response, status) => {
//     //     if (status === 'OK' && response.rows[0].elements[0].status === 'OK') {
//     //       const distance = response.rows[0].elements[0].distance.text;
//     //       setDistance(distance);
//     //     } else {
//     //       console.error('Error calculating distance:', status);
//     //       setDistance('');
//     //     }
//     //   }
//     // );
//   };
//   calculateDistance(pickUpLocation, dropOffLocation, setTotalDistance);
// }, [pickUpLocation,dropOffLocation]);
// {console.log("wwwwwwwpickupAddress",pickupAddress)}
const loadGoogleMapsScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      // If already loaded, resolve immediately
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = (error) => reject(error);

    document.head.appendChild(script);
  });
};


const toRadians = (degrees) => {
  return degrees * (Math.PI / 180);
};

const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInKilometers = R * c; // Distance in kilometers

  const distanceInMiles = distanceInKilometers * 0.621371; // Convert to miles
  return distanceInMiles;
};


useEffect(() => {
 const accordionsChanged = JSON.stringify(prevAccordionsRef.current) !== JSON.stringify(accordions);
    if (!accordionsChanged) return;

    prevAccordionsRef.current = accordions;
  const calculateDistance = async (pickupId, dropoffId,id) => {
    //console.log("allLocations=" ,allLocations);
    try {
      await loadGoogleMapsScript("AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI"); // Replace with your actual API key
    } catch (error) {
      console.error("Failed to load Google Maps API:", error);
      return;
    }

    const pickup = allLocations?.find((loc) => loc.loc_id == pickupId);
      const dropoff = allLocations?.find((loc) => loc.loc_id == dropoffId);
      // console.log("pickup=" ,pickup);
      // console.log("dropoff=" ,dropoff);
      if (!pickup || !dropoff) {
  console.warn('Missing results from geocoding');
  return;
}
  
      const pickupAddress = `${pickup.loc_address}, ${pickup.loc_city}, ${pickup.state?.state_name ?? ''}, ${pickup.loc_zip}`;
      const dropoffAddress = `${dropoff.loc_address}, ${dropoff.loc_city}, ${dropoff.state?.state_name ?? ''}, ${dropoff.loc_zip}`;
   
    try {
      // Fetch latitude and longitude for pickup
      const pickupResponse = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(pickupAddress)}&key=AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI`
      );
      const pickupData = await pickupResponse.json();
      if (pickupData.status !== "OK") {
        console.error("Geocoding failed for pickup:", pickupData.status);
        return;
      }
      const pickupLocation = pickupData.results[0].geometry.location;
  
      // Fetch latitude and longitude for dropoff
      const dropoffResponse = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(dropoffAddress)}&key=AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI`
      );
      const dropoffData = await dropoffResponse.json();
      if (dropoffData.status !== "OK") {
        console.error("Geocoding failed for dropoff:", dropoffData.status);
        return;
      }
      const dropoffLocation = dropoffData.results[0].geometry.location;
  
      // Calculate distance using Haversine formula
      const distance = calculateHaversineDistance(
        pickupLocation.lat,
        pickupLocation.lng,
        dropoffLocation.lat,
        dropoffLocation.lng
      );
  
      console.log(`Distancesss: ${distance.toFixed(2)} miles`);
      // if(id === 1){
      //   document.getElementById(`total_distance_2`).value = `${distance.toFixed(2)} miles`;
      // }
      //console.log('end',id);
      //document.getElementById(`total_distance_${id}`).value = `${distance.toFixed(2)} miles`;
      // setTotalDistance(`${distance.toFixed(2)} miles`);
      const field = document.getElementById(`total_distance_${id}`);
      if (field) field.textContent = `Distance : ${Math.round(distance)} miles`;
     setAccordions((prevAccordions) =>
      prevAccordions.map((accordion) =>
        accordion.id == id ? { 
          ...accordion, 
          distance: Math.round(distance),
          pickup_latitude: pickupLocation.lat,
          pickup_longitude: pickupLocation.lng,
          dropoff_latitude: dropoffLocation.lat,
          dropoff_longitude: dropoffLocation.lng
        } : accordion
      )
    );
      return distance;
    } catch (error) {
      console.error("Error calculating distance:", error);
    }
  };
  const processAllDistances = async () => {
    let total = 0;
    //console.log(`wwwwww: ${accordions} miles`);
    const promises = accordions.map(async (accordion) => {
      //console.log(`wwwwww: ${accordion} miles`);
      if (accordion.pick_up_loc && accordion.drop_off_loc) {
        const distance = await calculateDistance(accordion.pick_up_loc, accordion.drop_off_loc,accordion.id);
        const field = document.getElementById(`total_distance_${accordion.id}`);
        if (field) field.textContent = `Distance : ${Math.round(distance)} miles`;
        return distance;
      }
      return 0;
    });

    const distances = await Promise.all(promises);
    total = distances.reduce((sum, val) => sum + val, 0);

    console.log("Total Distance for all accordions:", total, "miles");
    // Optional: update to a DOM element or state
    
    const totalField = document.getElementById("total_all_distance");
    if (totalField) totalField.textContent = `Total Distance : ${Math.round(total)} miles`;
  };

  processAllDistances();
  // console.log("accordions",accordions);
  // accordions.forEach((accordion) => {
  //   // console.log("accordion",accordion);
  //   if (accordion.pick_up_loc && accordion.drop_off_loc) {
  //     calculateDistance(accordion.pick_up_loc, accordion.drop_off_loc, accordion.id);
  //   }
  // });
  
}, [accordions]);


return(
    <><div className="tab-pane fade active show " id="create-schedule" role="tabpanel" aria-labelledby="profile-tab">
    <section>
      <div className='d-flex justify-content-between form-container'>
        <div>
          <h2 className="fs-5 font-weight-600">Add Schedule </h2>
        </div>
        <div>
          <span>{currentDateFormat(currentDate)}</span>
        </div>
      </div>
    </section>
    <div className="container-fluid px-mobile-2 bg-white px-5 py-4">

      <section>
        <form action="#"> 
          <div className="form-create-schedule">
            <div className="search-client">
              <label className='require-field'>Search Passenger </label>
              <AutoComplete

                field='label'
                value={selectedPassenger}
                suggestions={filteredPassenger}
                completeMethod={search}
                onChange={(e) => setSelectedPassenger(e.value)}
                onSelect={(e) => handleLocationSelect(e.value)}
                className='search-box-autocomplete' />
            </div>

            <div className="form-item">
              <label>Passenger Name</label>
              <input type="text" readOnly={true} className="form-control" value={
              selectedPassenger?.value && 
              (selectedPassenger.value.first_name || selectedPassenger.value.middle_name || selectedPassenger.value.last_name) ? 
              (selectedPassenger.value.first_name || '') + ' ' + 
              (selectedPassenger.value.middle_name || '') + ' ' + 
              (selectedPassenger.value.last_name || '') : ''
            } id="client_name" name="client_name" />
            </div>
            <div>
              <label>Address</label>
              <input type="text" className="form-control" readOnly={true} id="address" name="address"
                value={(selectedPassenger.value?.address1 ? selectedPassenger.value?.address1 + ',' : '') +
                  (selectedPassenger.value?.address2 ? selectedPassenger.value?.address2 + ',' : '') +
                  (selectedPassenger.value?.city ? selectedPassenger.value?.city + ','  : '') +
                  (selectedPassenger.value?.state ? selectedPassenger.value?.state_master_lists?.state_name + ',' : '') +
                  (selectedPassenger.value?.zip ? selectedPassenger.value?.zip: '') 
                } />
            </div>
            <div>
              <label>Phone Number</label>
              <input type="text" className="form-control" readOnly={true} id="address" name="phone-number"
                value={selectedPassenger.value?.passenger?.pass_home_phn_no ?? ''} />
            </div>
            
          </div>
          <div className="form-payer-schedule">
            
            <div className="date-selector">
              <label>Date of Birth</label>
              <div className="input-group">
                <input type="text" readOnly={true} className="form-control datepicker hasDatepicker" id="client-dob" name="client_date_of_birth"
                  value={(dateFormat(selectedPassenger.value?.user_dob)) ?? ''} />

              </div>
            </div>
            <div>
              <label>Payer</label>
              <input type="text" readOnly={true} className="form-control" id="payer" name="payer"
                value={selectedPassenger.value?.passenger?.payer?.payer_name ?? ''} />
            </div>
            <div>
              <label>Insurance Number</label>
              <input type="text" readOnly={true} className="form-control" id="insurance_number" name="insurance_number"
                value={selectedPassenger.value?.passenger?.pass_insurance_no ?? ''} />
            </div>
          </div>
        </form>
      </section>
      <section>
        <div>
          <p className="sub-title">Add Schedule</p>
          
          {/* Debug section */}
          {/* <div style={{backgroundColor: '#f8f9fa', padding: '10px', marginBottom: '20px', fontSize: '12px', fontFamily: 'monospace'}}>
            <strong>Debug Info:</strong><br/>
            date_mode: {scheduleDetails.date_mode}<br/>
            frequency: {frequency}<br/>
            selectedDays: {JSON.stringify(selectedDays)}<br/>
            start_date: {startDate ? startDate.toLocaleDateString() : 'Not set'}<br/>
            end_date: {endDate ? endDate.toLocaleDateString() : 'Not set'}<br/>
            schedule_date: {scheduleDate ? scheduleDate.toLocaleDateString() : 'Not set'}
          </div> */}
        </div>

        <div className="add-new-trip">
          <form onSubmit={handleFormSubmit}>
          <div className="mb-2">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateMode"
                      id="singleDate"
                      value="single"
                      checked={scheduleDetails.date_mode === 'single'}
                      onChange={() => {
                        console.log('Date mode changed to single');
                        setScheduleDetails((prev) => ({ ...prev, date_mode: 'single' }));
                        // Reset frequency and selectedDays when switching to single mode
                        setFrequency('daily');
                        setSelectedDays([]);
                      }}
                    />
                    <label className="form-check-label" htmlFor="singleDate">Single Date</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateMode"
                      id="multipleDates"
                      value="range"
                      checked={scheduleDetails.date_mode === 'range'}
                      onChange={() => {
                        console.log('Date mode changed to range');
                        setScheduleDetails((prev) => ({ ...prev, date_mode: 'range' }));
                        // Reset frequency and selectedDays when switching to range mode
                        setFrequency('daily');
                        setSelectedDays([]);
                      }}
                    />
                    <label className="form-check-label" htmlFor="multipleDates">Multiple Days</label>
                  </div>
                </div>
                
                {/* Frequency selector for multiple days */}
                {(() => {
                  const shouldShowFrequency = scheduleDetails.date_mode === 'range';
                  console.log('Frequency selector rendering check:', {
                    date_mode: scheduleDetails.date_mode,
                    shouldShow: shouldShowFrequency
                  });
                  
                  return shouldShowFrequency ? (
                    <div className="mb-3 frequency-selector">
                      <label className="form-label">Frequency</label>
                      <div className="frequency-options-box">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="daily"
                            value="daily"
                            checked={frequency === 'daily'}
                            onChange={() => handleFrequencyChange('daily')}
                          />
                          <label className="form-check-label" htmlFor="daily">Daily</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="weekly"
                            value="weekly"
                            checked={frequency === 'weekly'}
                            onChange={() => handleFrequencyChange('weekly')}
                          />
                          <label className="form-check-label" htmlFor="weekly">Weekly</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="biweekly"
                            value="biweekly"
                            checked={frequency === 'biweekly'}
                            onChange={() => handleFrequencyChange('biweekly')}
                          />
                          <label className="form-check-label" htmlFor="biweekly">Bi-weekly</label>
                        </div>
                      </div>
                      {errors.frequency && <span className="errors">{errors.frequency}</span>}
                      {/* Debug info */}
                      {/* <div style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                        Debug: date_mode={scheduleDetails.date_mode}, frequency={frequency}
                      </div> */}
                    </div>
                  ) : null;
                })()}
                
                {/* Day selection for weekly and biweekly */}
                {(() => {
                  const shouldShowDaySelection = scheduleDetails.date_mode === 'range' && (frequency === 'weekly' || frequency === 'biweekly');
                  console.log('Day selection rendering check:', {
                    date_mode: scheduleDetails.date_mode,
                    frequency: frequency,
                    shouldShow: shouldShowDaySelection,
                    selectedDays: selectedDays
                  });
                  
                  return shouldShowDaySelection ? (
                    <div className="mb-3 day-selection">
                      <label className="form-label">Select Days</label>
                      <div className="d-flex gap-3">
                        {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`day-${index}`}
                              checked={selectedDays.includes(index)}
                              onChange={() => handleDaySelection(index)}
                            />
                            <label className="form-check-label" htmlFor={`day-${index}`}>
                              {day.substring(0, 3)}
                            </label>
                          </div>
                        ))}
                      </div>
                      {errors.selectedDays && <span className="errors">{errors.selectedDays}</span>}
                      {/* Debug info */}
                      {/* <div style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                        Debug: date_mode={scheduleDetails.date_mode}, frequency={frequency}, selectedDays={JSON.stringify(selectedDays)}
                      </div> */}
                    </div>
                  ) : null;
                })()}
            <div className='schedule-form-1'>
              <div className="row">
                <div className="col-3 date-selector align-top" >
                  {scheduleDetails.date_mode === 'single' ? (
                      <><label className='require-field'>Trip Date</label>
                      <div className="d-flex date-picker-wrapper schedule-date align-items-end">
                      <DatePicker
                        selected={scheduleDate}
                        dateFormat="MM/dd/yyyy"
                        autoComplete='off'
                        className="datepicker form-control hasDatepicker"
                        id="schedule_date"
                        name="schedule_date"
                        onChange={(date) => {
                          setScheduleDate(date);
                          handleInputChange({ 
                            target: { 
                              name: 'schedule_date', 
                              value: date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : '' } });
                        } }
                        ref={datepickerRef}
                        minDate={currentDate} />
                      <button
                        className="btn datepicker-button width-50"
                        type="button"
                        onClick={() => datepickerRef.current.setOpen(true)}
                      >
                        <img src={calender} className="img-fluid" width="20" height="20" alt="calender" />
                      </button>
                    </div>
                    {errors.schedule_date && <span className='errors'>{errors.schedule_date}</span>}
                    </>
                    ) : (
                    <div className="d-flex gap-2 multi-form align-items-end" >
                      
                      <div className='col-6 p-0'>
                        <div>
                        <label className='require-field'>Trip Date</label>
                      <DatePicker
                        selected={startDate}
                        dateFormat="MM/dd/yyyy"
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date) => {
                          setStartDate(date);
                          handleInputChange({ 
                            target:  { name: 'start_date', 
                              value: date? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` :''
                            } });
                        }}
                        className="form-control"
                        placeholderText="Start Date"
                        minDate={currentDate}
                        
                      />
                      </div>
                      {/* { errors.start_date && <span className="errors">{errors.start_date}</span>} */}
                      <div className="error-placeholder" style={{minHeight: '18px'}}>
                      {errors.start_date ? (
                          <span className="errors">{errors.start_date}</span>
                        ) : <span className="errors">&nbsp;</span>}
                      </div>
                      </div>
                      <div className='col-6 p-0'>
                        <div>
                        <label> &nbsp; </label>
                      <DatePicker
                        selected={endDate}
                        dateFormat="MM/dd/yyyy"
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date) => {
                          setEndDate(date);
                          handleInputChange({ 
                            target: { 
                              name: 'end_date', 
                              value: date ?
                              `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : ''
                            } });
                        }}
                        className="form-control"
                        placeholderText="End Date"
                        minDate={startDate || currentDate}
                      />
                      </div>
                      {/* {errors.end_date && <span className="errors">{errors.end_date}</span>} */}
                    <div className="error-placeholder" style={{minHeight: '18px'}}>
                          {/* <span class="errors">{errors.end_date && <span className="errors">{errors.end_date}</span>}</span> */}
                          {errors.end_date ? (
                        <span className="errors">{errors.end_date}</span>
                      ) : <span className="errors">&nbsp;</span>}
                        </div>
                      </div>
                      
                    </div>
                  )}             
                  
                </div>
                <div className="col-3">
                  <div>
                    <label>Assign Driver</label>
                    {/* <SelectDropDown options={assignedDriver} setValue={setSelectedValue} value={selectedValue} setErrors={setErrors}   /> */}
                    <select className="form-select" aria-label="Default select example" name="assigned_driver" onChange={handleInputChange}>
                      <option value="">Select</option>
                      {assignedDriver.map((driver, index) => (
                        <option key={index} value={driver.driver_id}>{driver.driver_name ? driver.driver_name : driver.full_name}</option>
                      ))}
                    </select>
                  </div>
                  
                </div>
                <div className="col-3">
                  <div>
                    <label className='require-field'>Location Type</label>
                    <div>
                      <select className="form-select" aria-label="Default select example" name="location_type" onChange={handleInputChange}>
                        <option value="">Select</option>
                        <option value="1">Pharmacy</option>
                        <option value="2">Hospital</option>
                        <option value="3">No Hospital</option>
                        <option value="4">Rehabitation</option>
                        <option value="5">Others</option>
                      </select>

                    </div>
                    {errors.location_type && <span className="errors">{errors.location_type}</span>}

                  </div>
                  
                </div>
                <div className="col-3">
                  <label>&nbsp;</label>
                    {/* {scheduleDetails.location_type === "5" && ( */}
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        name="other_location_type"
                        placeholder="Enter other location"
                        autoComplete='off'
                        disabled={disabledInput}
                        onChange={handleInputChange}
                      />
                      {errors.other_location_type && <span className="errors">{errors.other_location_type}</span>}
                    </div>
                    {/* )} */}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-2">
                    <label>WheelChair</label>
                    <div>
                      <select className="form-select" aria-label="Default select example" onChange={handleInputChange} name="wheel_chair">
                        <option value="">Select</option>
                        <option value="1">No</option>
                        <option value="2">yes</option>
                      </select>
                      {/* {errors.wheel_chair && <span className="errors">{errors.wheel_chair}</span>} */}
                    </div>
                </div>
                <div className="col-2">
                    <label>Stretcher</label>
                    <div>
                      <select className="form-select" aria-label="Default select example" onChange={handleInputChange} name="stretcher">
                        <option value="">Select</option>
                        <option value="1">No</option>
                        <option value="2">yes</option>
                      </select>
                    </div>
                    {/* {errors.stretcher && <span className="errors">{errors.stretcher}</span>} */}
                </div>
                <div className="col-1">
                  <label className='require-field'>No of Legs</label>
                  <div>
                    
                    <select 
                        className="form-select" 
                        aria-label="Default select example" 
                        value={numberOfLeg}
                        onChange={(e) => handleAccordianInputChange(accordions.id, 'number_of_leg', e.target.value)} 
                        name="number_of_leg">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                    {errors.number_of_leg && <span className="errors">{errors.number_of_leg}</span>}
                  </div>
                </div>
                
                  
                  {scheduleDetails.number_of_leg === "1" && (
                    <div className="col-2">
                        <div>
                          <label>&nbsp;</label>
                          <input
                            type="text"
                            className="form-control"
                            id="leg_one_text"
                            name="leg_one_text"
                            placeholder="No Load"
                            autoComplete='off'
                            onKeyDown={restrictSpecialCharacters}
                            onChange={handleInputChange}
                          />
                          {errors.leg_one_text && <span className="errors">{errors.leg_one_text}</span>}
                        </div>
                      </div>
                      )}

                
                <div className="col-2">
                  <label>Is There Any Wait Time</label>
                  <div>
                    <select 
                      className="form-select" 
                      aria-label="Default select example" 
                      onChange={handleInputChange} 
                      name="is_wait"
                      value={isWait}
                      >
                      <option value="">Select</option>
                      <option value="1">No</option>
                      <option value="2">yes</option>
                    </select>
                  </div>
                  {errors.is_wait && <span className="errors">{errors.is_wait}</span>}
                </div>
                {isWait === '2' && ( // Show input fields only if "Yes" is selected
                  <div className="col-2">
                    <div style={{ paddingTop: '30px' }}>
                        <input
                          type="number"
                          className="form-control float-start"
                          placeholder='Hour'
                          onInput={restrictNumberInput}
                          name='hour'
                          style={{ width: '82px',height:'36px' }}
                          
                          onChange={handleInputChange}
                        />
                        <input
                          type="number"
                          className="form-control float-end"
                          placeholder='Minute'
                          onInput={restrictNumberInput}
                          name='minute'
                          style={{ width: '82px',height:'36px' }}
                          
                          onChange={handleInputChange}
                        />
                      
                    </div>
                    <div>
                        {errors.hour && <span className="errors">{errors.hour}</span>}
                    </div>
                  </div>
                )}
                <div className="col-2">
                  <label className='require-field'>Bill Amount</label>
                  <div>
                    <input 
                    type="text"
                    className="form-control" 
                    id="bill_amount" 
                    name="bill_amount" 
                    onChange={(e) => {
                        const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                          // Valid input (empty or only digits)
                          handleInputChange(e); // Call your original handler
                        } else {
                          // Invalid input — block by resetting the value
                          e.target.value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                        }
                      }} />
                    {errors.bill_amount && <span className="errors">{errors.bill_amount}</span>}
                  </div>
                </div>
              </div>
              
              {/* Companion section */}
              <div className="row mt-3">
                <div className="col-3">
                  <label className='require-field'>Are there any companions traveling?</label>
                  <div className="d-flex gap-3 align-items-center">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="hasCompanions"
                        id="noCompanions"
                        value="No"
                        checked={hasCompanions === 'No'}
                        onChange={(e) => handleCompanionChange(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="noCompanions">No</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="hasCompanions"
                        id="yesCompanions"
                        value="Yes"
                        checked={hasCompanions === 'Yes'}
                        onChange={(e) => handleCompanionChange(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="yesCompanions">Yes</label>
                    </div>
                  </div>
                  {errors.has_companions && <span className="errors">{errors.has_companions}</span>}
                </div>
                
                {hasCompanions === 'Yes' && (
                  <div className="col-3">
                    <label className='require-field'>Number of Companions</label>
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        id="companion_count"
                        name="companion_count"
                        value={companionCount}
                        placeholder="Enter Companion count"
                        onChange={handleCompanionCountChange}
                        maxLength="2"
                      />
                      {errors.companion_count && <span className="errors">{errors.companion_count}</span>}
                    </div>
                  </div>
                )}
              </div>
              
              
              
            </div>
           
            <section>
              {/* Render Accordions dynamically */}
              {accordions.map((accordion) => (
                <Accordion style={{ background: '#80808012' }} key={accordion.id} expanded={accordion.expanded || accordionsWithError.includes(accordion.id)} onChange={() => handleToggle(accordion.id)}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${accordion.id}-content`}
                    id={`panel${accordion.id}-header`}
                  >
                    <Typography style={{ marginTop: '10px', fontWeight: 'bold', textDecoration: 'underline' }}>Leg {accordion.id}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div>

                      <div className="row pickup-time">
                        <div className="col-sm-12 col-md-8 col-lg-7 ps-2">
                          <div className="form-create-schedule">
                            <div>
                              <div>
                                <label className='require-field'>Pick Up Time</label>
                                {/* <TimePicker time={pickUpTime} setTime={setPickUpTime} type='1' setErrors={setErrors} /> */}

                                <select name="pick_up_time" className="form-select" id="pick_up_time" onChange={(e) => handleAccordianInputChange(accordion.id, 'pick_up_time', e.target.value)}>
                                      <option value="">Select</option>
                                      <option value="Will Call">Will Call</option>
                                      <option value="12:00 AM">12:00 AM</option>
                                      <option value="12:15 AM">12:15 AM</option>
                                      <option value="12:30 AM">12:30 AM</option>
                                      <option value="12:45 AM">12:45 AM</option>
                                      <option value="01:00 AM">01:00 AM</option>
                                      <option value="01:15 AM">01:15 AM</option>
                                      <option value="01:30 AM">01:30 AM</option>
                                      <option value="01:45 AM">01:45 AM</option>
                                      <option value="02:00 AM">02:00 AM</option>
                                      <option value="02:15 AM">02:15 AM</option>
                                      <option value="02:30 AM">02:30 AM</option>
                                      <option value="02:45 AM">02:45 AM</option>
                                      <option value="03:00 AM">03:00 AM</option>
                                      <option value="03:15 AM">03:15 AM</option>
                                      <option value="03:30 AM">03:30 AM</option>
                                      <option value="03:45 AM">03:45 AM</option>
                                      <option value="04:00 AM">04:00 AM</option>
                                      <option value="04:15 AM">04:15 AM</option>
                                      <option value="04:30 AM">04:30 AM</option>
                                      <option value="04:45 AM">04:45 AM</option>
                                      <option value="05:00 AM">05:00 AM</option>
                                      <option value="05:15 AM">05:15 AM</option>
                                      <option value="05:30 AM">05:30 AM</option>
                                      <option value="05:45 AM">05:45 AM</option>
                                      <option value="06:00 AM">06:00 AM</option>
                                      <option value="06:15 AM">06:15 AM</option>
                                      <option value="06:30 AM">06:30 AM</option>
                                      <option value="06:45 AM">06:45 AM</option>
                                      <option value="07:00 AM">07:00 AM</option>
                                      <option value="07:15 AM">07:15 AM</option>
                                      <option value="07:30 AM">07:30 AM</option>
                                      <option value="07:45 AM">07:45 AM</option>
                                      <option value="08:00 AM">08:00 AM</option>
                                      <option value="08:15 AM">08:15 AM</option>
                                      <option value="08:30 AM">08:30 AM</option>
                                      <option value="08:45 AM">08:45 AM</option>
                                      <option value="09:00 AM">09:00 AM</option>
                                      <option value="09:15 AM">09:15 AM</option>
                                      <option value="09:30 AM">09:30 AM</option>
                                      <option value="09:45 AM">09:45 AM</option>
                                      <option value="10:00 AM">10:00 AM</option>
                                      <option value="10:15 AM">10:15 AM</option>
                                      <option value="10:30 AM">10:30 AM</option>
                                      <option value="10:45 AM">10:45 AM</option>
                                      <option value="11:00 AM">11:00 AM</option>
                                      <option value="11:15 AM">11:15 AM</option>
                                      <option value="11:30 AM">11:30 AM</option>
                                      <option value="11:45 AM">11:45 AM</option>
                                      <option value="12:00 PM">12:00 PM</option>
                                      <option value="12:15 PM">12:15 PM</option>
                                      <option value="12:30 PM">12:30 PM</option>
                                      <option value="12:45 PM">12:45 PM</option>
                                      <option value="01:00 PM">01:00 PM</option>
                                      <option value="01:15 PM">01:15 PM</option>
                                      <option value="01:30 PM">01:30 PM</option>
                                      <option value="01:45 PM">01:45 PM</option>
                                      <option value="02:00 PM">02:00 PM</option>
                                      <option value="02:15 PM">02:15 PM</option>
                                      <option value="02:30 PM">02:30 PM</option>
                                      <option value="02:45 PM">02:45 PM</option>
                                      <option value="03:00 PM">03:00 PM</option>
                                      <option value="03:15 PM">03:15 PM</option>
                                      <option value="03:30 PM">03:30 PM</option>
                                      <option value="03:45 PM">03:45 PM</option>
                                      <option value="04:00 PM">04:00 PM</option>
                                      <option value="04:15 PM">04:15 PM</option>
                                      <option value="04:30 PM">04:30 PM</option>
                                      <option value="04:45 PM">04:45 PM</option>
                                      <option value="05:00 PM">05:00 PM</option>
                                      <option value="05:15 PM">05:15 PM</option>
                                      <option value="05:30 PM">05:30 PM</option>
                                      <option value="05:45 PM">05:45 PM</option>
                                      <option value="06:00 PM">06:00 PM</option>
                                      <option value="06:15 PM">06:15 PM</option>
                                      <option value="06:30 PM">06:30 PM</option>
                                      <option value="06:45 PM">06:45 PM</option>
                                      <option value="07:00 PM">07:00 PM</option>
                                      <option value="07:15 PM">07:15 PM</option>
                                      <option value="07:30 PM">07:30 PM</option>
                                      <option value="07:45 PM">07:45 PM</option>
                                      <option value="08:00 PM">08:00 PM</option>
                                      <option value="08:15 PM">08:15 PM</option>
                                      <option value="08:30 PM">08:30 PM</option>
                                      <option value="08:45 PM">08:45 PM</option>
                                      <option value="09:00 PM">09:00 PM</option>
                                      <option value="09:15 PM">09:15 PM</option>
                                      <option value="09:30 PM">09:30 PM</option>
                                      <option value="09:45 PM">09:45 PM</option>
                                      <option value="10:00 PM">10:00 PM</option>
                                      <option value="10:15 PM">10:15 PM</option>
                                      <option value="10:30 PM">10:30 PM</option>
                                      <option value="10:45 PM">10:45 PM</option>
                                      <option value="11:00 PM">11:00 PM</option>
                                      <option value="11:15 PM">11:15 PM</option>
                                      <option value="11:30 PM">11:30 PM</option>
                                      <option value="11:45 PM">11:45 PM</option>
                                      </select>

                                {errors[accordion.id]?.pick_up_time && <span className="errors">{errors[accordion.id].pick_up_time}</span>}
                              </div>
                            </div>

                            <div>
                              <label className='require-field'>Pick Up Location</label>
                              <select className="form-select"
                                aria-label="Default select example"
                                name="pick_up_loc"
                                value={accordion.pick_up_loc}
                                onChange={(e) => {
                                  handleAccordianInputChange(accordion.id, 'pick_up_loc', e.target.value);
                                  setSelectedPickUpLocations((prev) => ({
                                    ...prev,
                                    [accordion.id]: e.target.value, // Update state on change
                                  }));
                                } }>
                                <option value="">Select</option>
                                
                                {accordion.id === 2 && dropOffLocation && dropOffLocation.length > 0 && (
                                      // <option value={dropOffLocation[0].loc_id}>
                                      //   {dropOffLocation[0].loc_name + ',' + dropOffLocation[0].loc_address + ',' + (dropOffLocation[0]?.state?.state_name ?? '') + ',' + dropOffLocation[0].loc_city + ',' + dropOffLocation[0].loc_zip}
                                      // </option>
                                      (() => {
                                        const index = dropOffLocation.findIndex(location => location.loc_id == accordion.pick_up_loc );
                                        if (index !== -1) {
                                            const location = dropOffLocation[index];
                                            return (
                                                <option value={location.loc_id}>
                                                    {location.loc_name + ', ' + location.loc_address + ', ' + location.loc_city + ', ' + (location.state?.state_name ?? '') + ', '  + location.loc_zip}
                                                </option>
                                            );
                                        }
                                        return null; // or some other fallback if not found 
                                    })()
                                    )}
                                  {allLocations && allLocations.map((option, index) => (
                                    <option key={index} value={option.loc_id}>
                                      {option.loc_name + ',' + option.loc_address + ',' + option.loc_city + ',' + (option?.state?.state_name ?? '') + ','  + option.loc_zip}
                                    </option>
                                  ))}
                              </select>
                              {errors[accordion.id]?.pick_up_loc && <span className="errors">{errors[accordion.id].pick_up_loc}</span>}
                           {locationErrors[accordion.id] && (
                              <span className="text-danger">{locationErrors[accordion.id]}</span>
                            )}
                            </div>
                            <div className="align-self-md-end">
                              <PopupModal passId={selectedPassenger.value?.passenger?.passenger_id ?? ''} title="Add PickUp Location" toSetValue={setSetValue} locType='1' setValue={setLocationValue} addValue={locationValue} filterCriteria={1} handleResetAddValue={handleResetAddValue} />
                            </div>
                            <div>
                              <div>
                                <label className='require-field'>Drop off Time</label>
                                {/* <TimePicker time={dropOffTime} setTime={setDropOffTime} type='2' setErrors={setErrors} /> */}
                                <select name="drop_off_time" className="form-select" id="drop_off_time" onChange={(e) => handleAccordianInputChange(accordion.id, 'drop_off_time', e.target.value)}>
                                  <option value="">Select</option>
                                  <option value="Will Call">Will Call</option>
                                      <option value="12:00 AM">12:00 AM</option>
                                      <option value="12:15 AM">12:15 AM</option>
                                      <option value="12:30 AM">12:30 AM</option>
                                      <option value="12:45 AM">12:45 AM</option>
                                      <option value="01:00 AM">01:00 AM</option>
                                      <option value="01:15 AM">01:15 AM</option>
                                      <option value="01:30 AM">01:30 AM</option>
                                      <option value="01:45 AM">01:45 AM</option>
                                      <option value="02:00 AM">02:00 AM</option>
                                      <option value="02:15 AM">02:15 AM</option>
                                      <option value="02:30 AM">02:30 AM</option>
                                      <option value="02:45 AM">02:45 AM</option>
                                      <option value="03:00 AM">03:00 AM</option>
                                      <option value="03:15 AM">03:15 AM</option>
                                      <option value="03:30 AM">03:30 AM</option>
                                      <option value="03:45 AM">03:45 AM</option>
                                      <option value="04:00 AM">04:00 AM</option>
                                      <option value="04:15 AM">04:15 AM</option>
                                      <option value="04:30 AM">04:30 AM</option>
                                      <option value="04:45 AM">04:45 AM</option>
                                      <option value="05:00 AM">05:00 AM</option>
                                      <option value="05:15 AM">05:15 AM</option>
                                      <option value="05:30 AM">05:30 AM</option>
                                      <option value="05:45 AM">05:45 AM</option>
                                      <option value="06:00 AM">06:00 AM</option>
                                      <option value="06:15 AM">06:15 AM</option>
                                      <option value="06:30 AM">06:30 AM</option>
                                      <option value="06:45 AM">06:45 AM</option>
                                      <option value="07:00 AM">07:00 AM</option>
                                      <option value="07:15 AM">07:15 AM</option>
                                      <option value="07:30 AM">07:30 AM</option>
                                      <option value="07:45 AM">07:45 AM</option>
                                      <option value="08:00 AM">08:00 AM</option>
                                      <option value="08:15 AM">08:15 AM</option>
                                      <option value="08:30 AM">08:30 AM</option>
                                      <option value="08:45 AM">08:45 AM</option>
                                      <option value="09:00 AM">09:00 AM</option>
                                      <option value="09:15 AM">09:15 AM</option>
                                      <option value="09:30 AM">09:30 AM</option>
                                      <option value="09:45 AM">09:45 AM</option>
                                      <option value="10:00 AM">10:00 AM</option>
                                      <option value="10:15 AM">10:15 AM</option>
                                      <option value="10:30 AM">10:30 AM</option>
                                      <option value="10:45 AM">10:45 AM</option>
                                      <option value="11:00 AM">11:00 AM</option>
                                      <option value="11:15 AM">11:15 AM</option>
                                      <option value="11:30 AM">11:30 AM</option>
                                      <option value="11:45 AM">11:45 AM</option>
                                      <option value="12:00 PM">12:00 PM</option>
                                      <option value="12:15 PM">12:15 PM</option>
                                      <option value="12:30 PM">12:30 PM</option>
                                      <option value="12:45 PM">12:45 PM</option>
                                      <option value="01:00 PM">01:00 PM</option>
                                      <option value="01:15 PM">01:15 PM</option>
                                      <option value="01:30 PM">01:30 PM</option>
                                      <option value="01:45 PM">01:45 PM</option>
                                      <option value="02:00 PM">02:00 PM</option>
                                      <option value="02:15 PM">02:15 PM</option>
                                      <option value="02:30 PM">02:30 PM</option>
                                      <option value="02:45 PM">02:45 PM</option>
                                      <option value="03:00 PM">03:00 PM</option>
                                      <option value="03:15 PM">03:15 PM</option>
                                      <option value="03:30 PM">03:30 PM</option>
                                      <option value="03:45 PM">03:45 PM</option>
                                      <option value="04:00 PM">04:00 PM</option>
                                      <option value="04:15 PM">04:15 PM</option>
                                      <option value="04:30 PM">04:30 PM</option>
                                      <option value="04:45 PM">04:45 PM</option>
                                      <option value="05:00 PM">05:00 PM</option>
                                      <option value="05:15 PM">05:15 PM</option>
                                      <option value="05:30 PM">05:30 PM</option>
                                      <option value="05:45 PM">05:45 PM</option>
                                      <option value="06:00 PM">06:00 PM</option>
                                      <option value="06:15 PM">06:15 PM</option>
                                      <option value="06:30 PM">06:30 PM</option>
                                      <option value="06:45 PM">06:45 PM</option>
                                      <option value="07:00 PM">07:00 PM</option>
                                      <option value="07:15 PM">07:15 PM</option>
                                      <option value="07:30 PM">07:30 PM</option>
                                      <option value="07:45 PM">07:45 PM</option>
                                      <option value="08:00 PM">08:00 PM</option>
                                      <option value="08:15 PM">08:15 PM</option>
                                      <option value="08:30 PM">08:30 PM</option>
                                      <option value="08:45 PM">08:45 PM</option>
                                      <option value="09:00 PM">09:00 PM</option>
                                      <option value="09:15 PM">09:15 PM</option>
                                      <option value="09:30 PM">09:30 PM</option>
                                      <option value="09:45 PM">09:45 PM</option>
                                      <option value="10:00 PM">10:00 PM</option>
                                      <option value="10:15 PM">10:15 PM</option>
                                      <option value="10:30 PM">10:30 PM</option>
                                      <option value="10:45 PM">10:45 PM</option>
                                      <option value="11:00 PM">11:00 PM</option>
                                      <option value="11:15 PM">11:15 PM</option>
                                      <option value="11:30 PM">11:30 PM</option>
                                      <option value="11:45 PM">11:45 PM</option>
                                      </select>
                              </div>
                              {errors[accordion.id]?.drop_off_time && <span className="errors">{errors[accordion.id].drop_off_time}</span>}
                            </div>
                            <div>
                              <label className='require-field'>Drop off Location</label>
                              <div>
                                <select className="form-select" 
                                aria-label="Default select example" 
                                name="drop_off_loc" 
                                value={accordion.drop_off_loc}
                                onChange={(e) => {
                                handleAccordianInputChange(accordion.id, 'drop_off_loc', e.target.value);
                                setSelectedPickUpLocations((prev) => ({
                                  ...prev,
                                  [accordion.id]: e.target.value, // Update state on change
                                  }));
                                 } }>
                                  <option value="">Select</option>
                                  
                                  {accordion.id === 2 && pickUpLocation && pickUpLocation.length > 0 && (
                                      
                                      (() => {
                                        const index = pickUpLocation.findIndex(location => location.loc_id == accordion.drop_off_loc );
                                        if (index !== -1) {
                                            const location = pickUpLocation[index];
                                            return (
                                                <option value={location.loc_id}>
                                                    {location.loc_name + ', ' + location.loc_address + ', ' + (location.state?.state_name ?? '') + ', ' + location.loc_city + ', ' + location.loc_zip}
                                                </option>
                                            );
                                        }
                                        return null; // or some other fallback if not found
                                    })()
                                    )}
                                  {allLocations && allLocations.map((option, index) => (
                                    <option key={index} value={option.loc_id}>
                                      {option.loc_name + ',' + option.loc_address + ',' + (option?.state?.state_name ?? '') + ',' + option.loc_city + ',' + option.loc_zip}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {errors[accordion.id]?.drop_off_loc && <span className="errors">{errors[accordion.id].drop_off_loc}</span>}
                            </div>
                            <div className="align-self-md-end">
                              <PopupModal passId={selectedPassenger.value?.passenger?.passenger_id ?? ''} title="Add DropOff Location" locType='2' toSetValue={setSetValue} setValue={setLocationValue} addValue={locationValue} filterCriteria={2} handleResetAddValue={handleResetAddValue} />
                            </div>
                          </div>
                         <div>
                         {/* <label>Total Distance</label> */}
                         <div className='accordian-distance' name="total-distance" id={`total_distance_${accordion.id}`}> </div>
                         </div>
                        </div>
                      </div>

                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}

              {/* Submit button for all data */}
              <div>
                <div className='accordian-distance' name="total_all_distance" id="total_all_distance"></div>
              </div>
              <div className="client-notes" style={{ marginTop: '20px' }}>
                <label>Notes</label>
                <div>
                  <textarea className="alert alert-light" name="schedule_note" role="alert" style={{ width: '100%' }} onChange={handleInputChange}></textarea>
                </div>
              </div>
            </section>
            <div className='footer-content' style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
              {/* <SaveButton type='submit' buttonTitle={'ADD SCHEDULE'}/> */}

              <Button variant="contained" color="primary" onClick={handleFormSubmit}>
                ADD SCHEDULE
              </Button>

              <CancelButton cancelHandler={() => navigate('list')} />
            </div>

          </form>
        </div>
      </section>
    </div>
  </div><div> {loading && <Loader />}</div></>
);
}
export default Schedule;



